import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/* Central store for small pieces of UI state we want to survive navigation and
 * refresh — pagination page numbers and boolean view toggles. Keyed by string
 * so any surface opts in with its own key; the reducers write by key with no
 * per-surface code. */
export interface PersistedUiState {
  [key: string]: number | boolean;
}

export const PAGINATION_KEYS = {
  serviceRequestDashboard: 'sr-dashboard',
  contacts: 'contacts',
  suites: 'suites',
  contactServiceRequests: 'contact-service-requests',
  propertyServiceRequests: 'property-service-requests',
  suiteServiceRequests: 'suite-service-requests',
  itemServiceRequests: 'item-service-requests',
  inbox: 'inbox'
} as const;

export const TOGGLE_KEYS = {
  serviceRequestDashboardShowResolved: 'sr-dashboard-show-resolved',
  serviceRequestDashboardSubscribedOnly: 'sr-dashboard-subscribed-only',
} as const;

const initialState: PersistedUiState = {};

const persistedUiSlice = createSlice({
  name: 'persistedUi',
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<{ key: string; page: number }>) => {
      const { key, page } = action.payload;
      state[key] = page;
    },
    setToggle: (
      state,
      action: PayloadAction<{ key: string; value: boolean }>
    ) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
});

export const { setPage: setPageAction, setToggle: setToggleAction } =
  persistedUiSlice.actions;
export default persistedUiSlice.reducer;
